import { Controller } from "@hotwired/stimulus";
import { marked } from "marked";

export default class extends Controller {
  static targets = ["output"];
  static values = { content: String };

  connect() {
    this.configureMarked();
    this.renderTimeout = null;
    this.render();
  }

  disconnect() {
    if (this.renderTimeout) {
      clearTimeout(this.renderTimeout);
      this.renderTimeout = null;
    }
  }

  configureMarked() {
    marked.use({
      breaks: true,
      gfm: true,
    });
  }

  contentValueChanged() {
    if (this.renderTimeout) {
      clearTimeout(this.renderTimeout);
    }

    this.renderTimeout = setTimeout(() => {
      this.render();
    }, 100);
  }

  render() {
    if (!this.contentValue) {
      this.outputTarget.innerHTML = "";
      return;
    }

    try {
      const html = marked(this.contentValue);
      this.outputTarget.innerHTML = html;
      this.scrollToBottom();
    } catch (error) {
      console.error("Markdown rendering error:", error);
      this.outputTarget.innerHTML = `<p class="error">Error rendering markdown</p>`;
    }
  }

  scrollToBottom() {
    window.scrollTo(0, document.body.scrollHeight);
  }
}
